import { api } from '/@src/services/api.service.js';

export const sendHeartbeat = (isIdle) => api.post('heartbeat', { isIdle });
